const LIGHT_THEME_TOKENS: Record<string, string> = {
    "--color-background": "hsl(0 0% 100%)",
    "--color-foreground": "hsl(240 10% 3.9%)",
    "--color-card": "hsl(0 0% 100%)",
    "--color-card-foreground": "hsl(240 10% 3.9%)",
    "--color-popover": "hsl(0 0% 100%)",
    "--color-popover-foreground": "hsl(240 10% 3.9%)",
    "--color-primary": "hsl(240 5.9% 10%)",
    "--color-primary-foreground": "hsl(0 0% 98%)",
    "--color-secondary": "hsl(240 4.8% 95.9%)",
    "--color-secondary-foreground": "hsl(240 5.9% 10%)",
    "--color-muted": "hsl(240 4.8% 95.9%)",
    "--color-muted-foreground": "hsl(240 3.8% 46.1%)",
    "--color-accent": "hsl(240 4.8% 95.9%)",
    "--color-accent-foreground": "hsl(240 5.9% 10%)",
    "--color-destructive": "hsl(0 84.2% 60.2%)",
    "--color-destructive-foreground": "hsl(0 0% 98%)",
    "--color-border": "hsl(240 5.9% 90%)",
    "--color-input": "hsl(240 5.9% 90%)",
    "--color-ring": "hsl(240 5.9% 64.9%)",
    "--color-info": "hsl(199 89% 48%)",
    "--color-success": "hsl(142 71% 45%)",
    "--color-warning": "hsl(38 92% 50%)",
    "--color-preview-surface": "hsl(40 20% 98.5%)",
    "--syntax-keyword": "#5E81AC",
    "--syntax-string": "#A3BE8C",
    "--syntax-comment": "#939daa",
    "--syntax-number": "#B48EAD",
    "--syntax-function": "#88C0D0",
    "--syntax-variable": "#434C5E",
    "--syntax-type": "#EBCB8B",
    "--syntax-link": "#5E81AC",
    "--syntax-tag": "#81A1C1",
    "--syntax-attribute": "#8FBCBB",
    "--syntax-heading": "#5E81AC",
    "--syntax-emphasis": "#B48EAD",
    "--syntax-strong": "#5E81AC",
    "--syntax-strikethrough": "#939daa",
    "--syntax-quote": "#939daa",
    "--syntax-code": "#D08770",
    "--syntax-separator": "#D8DEE9",
    "--syntax-list": "#81A1C1",
    "--syntax-bracket": "#939daa",
    "--syntax-operator": "#81A1C1",
};

const DARK_THEME_TOKENS: Record<string, string> = {
    "--color-background": "hsl(240 10% 3.9%)",
    "--color-foreground": "hsl(0 0% 98%)",
    "--color-card": "hsl(240 10% 3.9%)",
    "--color-card-foreground": "hsl(0 0% 98%)",
    "--color-popover": "hsl(240 10% 3.9%)",
    "--color-popover-foreground": "hsl(0 0% 98%)",
    "--color-primary": "hsl(0 0% 98%)",
    "--color-primary-foreground": "hsl(240 5.9% 10%)",
    "--color-secondary": "hsl(240 3.7% 15.9%)",
    "--color-secondary-foreground": "hsl(0 0% 98%)",
    "--color-muted": "hsl(240 3.7% 15.9%)",
    "--color-muted-foreground": "hsl(240 5% 64.9%)",
    "--color-accent": "hsl(240 3.7% 15.9%)",
    "--color-accent-foreground": "hsl(0 0% 98%)",
    "--color-destructive": "hsl(0 62.8% 30.6%)",
    "--color-destructive-foreground": "hsl(0 0% 98%)",
    "--color-border": "hsl(240 3.7% 15.9%)",
    "--color-input": "hsl(240 3.7% 15.9%)",
    "--color-ring": "hsl(240 4.9% 83.9%)",
    "--color-info": "hsl(199 89% 60%)",
    "--color-success": "hsl(142 65% 55%)",
    "--color-warning": "hsl(38 95% 58%)",
    "--color-preview-surface": "hsl(220 8% 7%)",
    "--syntax-keyword": "#81A1C1",
    "--syntax-string": "#A3BE8C",
    "--syntax-comment": "#616E88",
    "--syntax-number": "#B48EAD",
    "--syntax-function": "#88C0D0",
    "--syntax-variable": "#D8DEE9",
    "--syntax-type": "#EBCB8B",
    "--syntax-link": "#88C0D0",
    "--syntax-tag": "#81A1C1",
    "--syntax-attribute": "#8FBCBB",
    "--syntax-heading": "#88C0D0",
    "--syntax-emphasis": "#B48EAD",
    "--syntax-strong": "#88C0D0",
    "--syntax-strikethrough": "#616E88",
    "--syntax-quote": "#616E88",
    "--syntax-code": "#D08770",
    "--syntax-separator": "#4C566A",
    "--syntax-list": "#81A1C1",
    "--syntax-bracket": "#616E88",
    "--syntax-operator": "#81A1C1",
};

const GITHUB_LIGHT_THEME_TOKENS: Record<string, string> = {
    ...LIGHT_THEME_TOKENS,
    "--color-background": "#ffffff",
    "--color-foreground": "#1f2328",
    "--color-card": "#ffffff",
    "--color-card-foreground": "#1f2328",
    "--color-popover": "#ffffff",
    "--color-popover-foreground": "#1f2328",
    "--color-primary": "#0969da",
    "--color-primary-foreground": "#ffffff",
    "--color-secondary": "#f6f8fa",
    "--color-secondary-foreground": "#24292f",
    "--color-muted": "#f6f8fa",
    "--color-muted-foreground": "#57606a",
    "--color-accent": "#ddf4ff",
    "--color-accent-foreground": "#0a3069",
    "--color-destructive": "#cf222e",
    "--color-destructive-foreground": "#ffffff",
    "--color-border": "#d0d7de",
    "--color-input": "#d0d7de",
    "--color-ring": "#0969da",
    "--color-info": "#0969da",
    "--color-success": "#1a7f37",
    "--color-warning": "#9a6700",
    "--color-preview-surface": "#fbfdff",
    "--syntax-keyword": "#cf222e",
    "--syntax-string": "#0a3069",
    "--syntax-comment": "#6e7781",
    "--syntax-number": "#8250df",
    "--syntax-function": "#8250df",
    "--syntax-variable": "#1f2328",
    "--syntax-type": "#953800",
    "--syntax-link": "#0969da",
    "--syntax-tag": "#116329",
    "--syntax-attribute": "#0550ae",
    "--syntax-heading": "#0550ae",
    "--syntax-emphasis": "#8250df",
    "--syntax-strong": "#1f2328",
    "--syntax-strikethrough": "#6e7781",
    "--syntax-quote": "#57606a",
    "--syntax-code": "#0550ae",
    "--syntax-separator": "#d8dee4",
    "--syntax-list": "#0969da",
    "--syntax-bracket": "#6e7781",
    "--syntax-operator": "#cf222e",
};

const GITHUB_DARK_THEME_TOKENS: Record<string, string> = {
    ...DARK_THEME_TOKENS,
    "--color-background": "#0d1117",
    "--color-foreground": "#e6edf3",
    "--color-card": "#161b22",
    "--color-card-foreground": "#e6edf3",
    "--color-popover": "#161b22",
    "--color-popover-foreground": "#e6edf3",
    "--color-primary": "#2f81f7",
    "--color-primary-foreground": "#ffffff",
    "--color-secondary": "#21262d",
    "--color-secondary-foreground": "#c9d1d9",
    "--color-muted": "#21262d",
    "--color-muted-foreground": "#8b949e",
    "--color-accent": "#1f6feb26",
    "--color-accent-foreground": "#cae8ff",
    "--color-destructive": "#f85149",
    "--color-destructive-foreground": "#ffffff",
    "--color-border": "#30363d",
    "--color-input": "#30363d",
    "--color-ring": "#2f81f7",
    "--color-info": "#2f81f7",
    "--color-success": "#3fb950",
    "--color-warning": "#d29922",
    "--color-preview-surface": "#11161d",
    "--syntax-keyword": "#ff7b72",
    "--syntax-string": "#a5d6ff",
    "--syntax-comment": "#8b949e",
    "--syntax-number": "#79c0ff",
    "--syntax-function": "#d2a8ff",
    "--syntax-variable": "#e6edf3",
    "--syntax-type": "#ffa657",
    "--syntax-link": "#2f81f7",
    "--syntax-tag": "#7ee787",
    "--syntax-attribute": "#79c0ff",
    "--syntax-heading": "#1f6feb",
    "--syntax-emphasis": "#d2a8ff",
    "--syntax-strong": "#e6edf3",
    "--syntax-strikethrough": "#8b949e",
    "--syntax-quote": "#8b949e",
    "--syntax-code": "#79c0ff",
    "--syntax-separator": "#30363d",
    "--syntax-list": "#2f81f7",
    "--syntax-bracket": "#8b949e",
    "--syntax-operator": "#ff7b72",
};

const CLAUDE_LIGHT_THEME_TOKENS: Record<string, string> = {
    ...LIGHT_THEME_TOKENS,
    "--color-background": "#f8f5ee",
    "--color-foreground": "#2b2118",
    "--color-card": "#fffaf3",
    "--color-card-foreground": "#2b2118",
    "--color-popover": "#fffcf7",
    "--color-popover-foreground": "#2b2118",
    "--color-primary": "#c96442",
    "--color-primary-foreground": "#fff8f1",
    "--color-secondary": "#eee7dc",
    "--color-secondary-foreground": "#3c3027",
    "--color-muted": "#f1ece3",
    "--color-muted-foreground": "#7c7166",
    "--color-accent": "#eadfd2",
    "--color-accent-foreground": "#3d2a1f",
    "--color-destructive": "#b43b32",
    "--color-destructive-foreground": "#fff8f1",
    "--color-border": "#d8d0c3",
    "--color-input": "#d8d0c3",
    "--color-ring": "#c96442",
    "--color-info": "#42758a",
    "--color-success": "#5f7f45",
    "--color-warning": "#b87333",
    "--color-preview-surface": "#fbf7ef",
    "--syntax-keyword": "#8f4f2f",
    "--syntax-string": "#6f7e3d",
    "--syntax-comment": "#9a8f82",
    "--syntax-number": "#9b5f86",
    "--syntax-function": "#b75f3a",
    "--syntax-variable": "#3f342d",
    "--syntax-type": "#7a633b",
    "--syntax-link": "#9f5a3d",
    "--syntax-tag": "#b75f3a",
    "--syntax-attribute": "#6f7e3d",
    "--syntax-heading": "#8b4a2f",
    "--syntax-emphasis": "#a55d50",
    "--syntax-strong": "#2b2118",
    "--syntax-strikethrough": "#9a8f82",
    "--syntax-quote": "#8a7c70",
    "--syntax-code": "#b75f3a",
    "--syntax-separator": "#d8d0c3",
    "--syntax-list": "#b75f3a",
    "--syntax-bracket": "#8a7c70",
    "--syntax-operator": "#9f5a3d",
};

const COMFORT_LIGHT_THEME_TOKENS: Record<string, string> = {
    ...LIGHT_THEME_TOKENS,
    "--color-background": "#faf9f5",
    "--color-foreground": "#24313a",
    "--color-card": "#fffdf9",
    "--color-card-foreground": "#24313a",
    "--color-popover": "#ffffff",
    "--color-popover-foreground": "#24313a",
    "--color-primary": "#2f6f73",
    "--color-primary-foreground": "#faf9f5",
    "--color-secondary": "#eef0ed",
    "--color-secondary-foreground": "#2d3a3f",
    "--color-muted": "#f0f1ed",
    "--color-muted-foreground": "#66747c",
    "--color-accent": "#e7f0ef",
    "--color-accent-foreground": "#1f5156",
    "--color-destructive": "#b24a44",
    "--color-destructive-foreground": "#fff8f5",
    "--color-border": "#d7dcd8",
    "--color-input": "#d7dcd8",
    "--color-ring": "#2f6f73",
    "--color-info": "#456f9c",
    "--color-success": "#4c7a54",
    "--color-warning": "#92551f",
    "--color-preview-surface": "#fcfbf8",
    "--syntax-keyword": "#5e6689",
    "--syntax-string": "#4c7a54",
    "--syntax-comment": "#879099",
    "--syntax-number": "#8a6b3a",
    "--syntax-function": "#2f6f73",
    "--syntax-variable": "#24313a",
    "--syntax-type": "#887044",
    "--syntax-link": "#456f9c",
    "--syntax-tag": "#8a5a6a",
    "--syntax-attribute": "#4c7a54",
    "--syntax-heading": "#2f6f73",
    "--syntax-emphasis": "#7b5b86",
    "--syntax-strong": "#24313a",
    "--syntax-strikethrough": "#879099",
    "--syntax-quote": "#66747c",
    "--syntax-code": "#8a5a3a",
    "--syntax-separator": "#d7dcd8",
    "--syntax-list": "#2f6f73",
    "--syntax-bracket": "#879099",
    "--syntax-operator": "#5e6689",
};

const COMFORT_DARK_THEME_TOKENS: Record<string, string> = {
    ...DARK_THEME_TOKENS,
    "--color-background": "#13161a",
    "--color-foreground": "#e7e1d7",
    "--color-card": "#1a1e22",
    "--color-card-foreground": "#e7e1d7",
    "--color-popover": "#20252a",
    "--color-popover-foreground": "#e7e1d7",
    "--color-primary": "#86b7b3",
    "--color-primary-foreground": "#101416",
    "--color-secondary": "#22272c",
    "--color-secondary-foreground": "#d8d2c8",
    "--color-muted": "#22272c",
    "--color-muted-foreground": "#a6a095",
    "--color-accent": "#24383b",
    "--color-accent-foreground": "#c9e0dc",
    "--color-destructive": "#d67c74",
    "--color-destructive-foreground": "#161313",
    "--color-border": "#32373d",
    "--color-input": "#32373d",
    "--color-ring": "#86b7b3",
    "--color-info": "#8fb4d9",
    "--color-success": "#93bc86",
    "--color-warning": "#d7a75b",
    "--color-preview-surface": "#171b1f",
    "--syntax-keyword": "#b79bd7",
    "--syntax-string": "#a8c88a",
    "--syntax-comment": "#7d858c",
    "--syntax-number": "#d7a75b",
    "--syntax-function": "#86b7b3",
    "--syntax-variable": "#e7e1d7",
    "--syntax-type": "#c8b17a",
    "--syntax-link": "#8fb4d9",
    "--syntax-tag": "#d67c74",
    "--syntax-attribute": "#93bc86",
    "--syntax-heading": "#86b7b3",
    "--syntax-emphasis": "#c9a4d8",
    "--syntax-strong": "#f0eadf",
    "--syntax-strikethrough": "#7d858c",
    "--syntax-quote": "#a6a095",
    "--syntax-code": "#e09a72",
    "--syntax-separator": "#32373d",
    "--syntax-list": "#86b7b3",
    "--syntax-bracket": "#7d858c",
    "--syntax-operator": "#b79bd7",
};

const SOLARIZED_LIGHT_THEME_TOKENS: Record<string, string> = {
    ...LIGHT_THEME_TOKENS,
    "--color-background": "#fdf6e3",
    "--color-foreground": "#657b83",
    "--color-card": "#fdf6e3",
    "--color-card-foreground": "#657b83",
    "--color-popover": "#eee8d5",
    "--color-popover-foreground": "#657b83",
    "--color-primary": "#268bd2",
    "--color-primary-foreground": "#fdf6e3",
    "--color-secondary": "#eee8d5",
    "--color-secondary-foreground": "#586e75",
    "--color-muted": "#eee8d5",
    "--color-muted-foreground": "#93a1a1",
    "--color-accent": "#eee8d5",
    "--color-accent-foreground": "#586e75",
    "--color-destructive": "#dc322f",
    "--color-destructive-foreground": "#fdf6e3",
    "--color-border": "#d3cdb9",
    "--color-input": "#d3cdb9",
    "--color-ring": "#268bd2",
    "--color-info": "#268bd2",
    "--color-success": "#859900",
    "--color-warning": "#b58900",
    "--color-preview-surface": "#faf3e0",
    "--syntax-keyword": "#859900",
    "--syntax-string": "#2aa198",
    "--syntax-comment": "#93a1a1",
    "--syntax-number": "#d33682",
    "--syntax-function": "#268bd2",
    "--syntax-variable": "#657b83",
    "--syntax-type": "#b58900",
    "--syntax-link": "#268bd2",
    "--syntax-tag": "#268bd2",
    "--syntax-attribute": "#2aa198",
    "--syntax-heading": "#cb4b16",
    "--syntax-emphasis": "#d33682",
    "--syntax-strong": "#586e75",
    "--syntax-strikethrough": "#93a1a1",
    "--syntax-quote": "#93a1a1",
    "--syntax-code": "#cb4b16",
    "--syntax-separator": "#d3cdb9",
    "--syntax-list": "#268bd2",
    "--syntax-bracket": "#93a1a1",
    "--syntax-operator": "#859900",
};

const SOLARIZED_DARK_THEME_TOKENS: Record<string, string> = {
    ...DARK_THEME_TOKENS,
    "--color-background": "#002b36",
    "--color-foreground": "#839496",
    "--color-card": "#073642",
    "--color-card-foreground": "#839496",
    "--color-popover": "#073642",
    "--color-popover-foreground": "#839496",
    "--color-primary": "#268bd2",
    "--color-primary-foreground": "#fdf6e3",
    "--color-secondary": "#073642",
    "--color-secondary-foreground": "#93a1a1",
    "--color-muted": "#073642",
    "--color-muted-foreground": "#657b83",
    "--color-accent": "#073642",
    "--color-accent-foreground": "#93a1a1",
    "--color-destructive": "#dc322f",
    "--color-destructive-foreground": "#fdf6e3",
    "--color-border": "#586e75",
    "--color-input": "#586e75",
    "--color-ring": "#268bd2",
    "--color-info": "#268bd2",
    "--color-success": "#859900",
    "--color-warning": "#b58900",
    "--color-preview-surface": "#001e27",
    "--syntax-keyword": "#859900",
    "--syntax-string": "#2aa198",
    "--syntax-comment": "#586e75",
    "--syntax-number": "#d33682",
    "--syntax-function": "#268bd2",
    "--syntax-variable": "#839496",
    "--syntax-type": "#b58900",
    "--syntax-link": "#268bd2",
    "--syntax-tag": "#268bd2",
    "--syntax-attribute": "#2aa198",
    "--syntax-heading": "#cb4b16",
    "--syntax-emphasis": "#d33682",
    "--syntax-strong": "#93a1a1",
    "--syntax-strikethrough": "#586e75",
    "--syntax-quote": "#586e75",
    "--syntax-code": "#cb4b16",
    "--syntax-separator": "#586e75",
    "--syntax-list": "#268bd2",
    "--syntax-bracket": "#586e75",
    "--syntax-operator": "#859900",
};

export const BUILTIN_THEME_TOKENS: Record<string, Record<string, string>> = {
    "magicmd.workbench-light": LIGHT_THEME_TOKENS,
    "magicmd.workbench-dark": DARK_THEME_TOKENS,
    "magicmd.github-light": GITHUB_LIGHT_THEME_TOKENS,
    "magicmd.github-dark": GITHUB_DARK_THEME_TOKENS,
    "magicmd.claude-light": CLAUDE_LIGHT_THEME_TOKENS,
    "magicmd.comfort-light": COMFORT_LIGHT_THEME_TOKENS,
    "magicmd.comfort-dark": COMFORT_DARK_THEME_TOKENS,
    "magicmd.solarized-light": SOLARIZED_LIGHT_THEME_TOKENS,
    "magicmd.solarized-dark": SOLARIZED_DARK_THEME_TOKENS,
};

const KNOWN_THEME_TOKEN_NAMES = [
    ...new Set(
        Object.values(BUILTIN_THEME_TOKENS).flatMap((tokens) => Object.keys(tokens)),
    ),
];

export function applyBuiltInThemeTokens(
    root: HTMLElement,
    themeId: string,
): void {
    const tokens = BUILTIN_THEME_TOKENS[themeId];
    if (!tokens) {
        for (const name of KNOWN_THEME_TOKEN_NAMES) {
            root.style.removeProperty(name);
        }
        return;
    }

    for (const name of KNOWN_THEME_TOKEN_NAMES) {
        const value = tokens[name];
        if (value) {
            root.style.setProperty(name, value);
        } else {
            root.style.removeProperty(name);
        }
    }
}
